import request from '@/libs/request'

//出库单 列表
export function warehouseInventoryOutListApi (data) {
  return request({
    url: `warehouse/warehouseInventoryOut`,
    method: 'get',
    params: data
  })
}

//出库单 详情
export function warehouseInventoryOutInfoApi (id) {
  return request({
    url: `warehouse/warehouseInventoryOut/` + id,
    method: 'get'
  })
}


//出库单 编辑/添加
export function warehouseInventoryOutSaveApi (data) {
  return request({
    url: `warehouse/warehouseInventoryOut`,
    method: 'post',
    data: data
  })
}

//出库单 审核
export function warehouseInventoryOutAuditApi (data) {
  return request({
    url: `warehouse/warehouseInventoryOutApi/audit`,
    method: 'post',
    data: data
  })
}


